import React, { useState } from 'react';
import { menuItems } from '../../constants/navData';
import { Link } from 'gatsby';
import { ChevronDown } from 'lucide-react';

export default function MobileMenu({
	setIsNavOpen,
	isNavOpen,
	currentLocation,
}) {
	const [openDropdown, setOpenDropdown] = useState(null);

	const toggleDropdown = (title) => {
		setOpenDropdown(openDropdown === title ? null : title);
	};

	return (
		<nav
			className={`md:hidden z-[1002] fixed top-20 right-0 w-full bg-white/80 backdrop-blur-lg h-screen flex items-start justify-center ease duration-300 transform ${
				isNavOpen ? 'translate-y-0' : '-translate-y-[120%]'
			}`}
		>
			<ul className='w-full'>
				{menuItems.map((item) => (
					<li key={item.path || item.title} className={`group w-full`}>
						{item.hasDropdown ? (
							<>
								<button
									onClick={() => toggleDropdown(item.title)}
									className={`text-[#64718A] flex items-center justify-between text-2xl font-medium tracking-wider py-4 group-hover:text-black before-link w-full px-12`}
								>
									{item.title}
									<ChevronDown
										className={`h-5 w-5 transition-transform duration-200 ${
											openDropdown === item.title ? 'rotate-180' : ''
										}`}
									/>
								</button>
								<ul
									className={`overflow-hidden transition-all duration-300 bg-gray-50 ${
										openDropdown === item.title
											? 'max-h-96 opacity-100'
											: 'max-h-0 opacity-0'
									}`}
								>
									{item.children.map((child) => (
										<li key={child.path}>
											<Link
												onClick={() => setIsNavOpen(false)}
												to={child.path}
												className={`text-[#64718A] flex text-xl font-medium tracking-wider py-3 hover:text-black w-full pl-16 pr-12 ${
													child.path === currentLocation
														? 'bg-gray-200 text-black'
														: ''
												}`}
											>
												{child.title}
											</Link>
										</li>
									))}
								</ul>
							</>
						) : (
							<Link
								onClick={() => setIsNavOpen(false)}
								to={
									item.path.includes('#')
										? `/${item.path}`
										: item.path
								}
								className={`text-[#64718A] flex text-2xl font-medium tracking-wider py-4 group-hover:text-black before-link w-full px-12 ${
									item.path === currentLocation
										? 'bg-gray-200 text-black'
										: ''
								}`}
							>
								{item.title}
							</Link>
						)}
					</li>
				))}
			</ul>
		</nav>
	);
}
